/* ============================================================
   BSS CUSTOM JS — LaFit Active
   Bold Soul Studio
   ============================================================ */


/* ============================================================
   1. SWATCH NAME REMAPPING
   Maps Shopify generic colour names to LaFit brand names
   on product swatches and variant labels.
   ============================================================ */

const LAFIT_COLOUR_MAP = {
  'black':      'Midnight',
  'white':      'Chalk',
  'beige':      'Ice Latte',
  'cream':      'Ice Latte',
  'brown':      'Espresso',
  'taupe':      'Chai',
  'bronze':     'Chai',
  'blue':       'Rain',
  'light blue': 'Stone',
  'grey':       'Dusk',
  'gray':       'Dusk',
};

function remapSwatchNames() {
  const selectors = [
    '.swatch__label',
    '.variant-swatch__label',
    '[data-swatch-label]',
    '.product-form__option-name',
    '.color-swatch__name',
  ];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      const raw = el.textContent.trim().toLowerCase();
      if (LAFIT_COLOUR_MAP[raw]) el.textContent = LAFIT_COLOUR_MAP[raw];
    });
  });
}

document.addEventListener('DOMContentLoaded', remapSwatchNames);
document.addEventListener('shopify:section:load', remapSwatchNames);
const swatchObserver = new MutationObserver(remapSwatchNames);
swatchObserver.observe(document.body, { childList: true, subtree: true });


/* ============================================================
   2. FILTER PANEL SWATCH COLOUR FIX
   Overrides --swatch-background CSS variable on collection
   filter panel swatches using LaFit brand hex values.
   Targets: label.filter-swatch > span.visually-hidden
   ============================================================ */

const LAFIT_FILTER_COLOURS = {
  'beige':      '#EFE5DA', // Iced Latte
  'black':      '#1C1C1A', // Midnight
  'blue':       '#7A91A8', // Rain
  'light blue': '#B0C3D1', // Stone
  'bronze':     '#A17070', // Chai
  'brown':      '#523832', // Espresso / Choco
  'white':      '#FFFFFF', // Chalk
  'grey':       '#9AA0A6', // Dusk
  'gray':       '#9AA0A6', // Dusk (alternate spelling)
  'cream':      '#EFE5DA', // Iced Latte
  'taupe':      '#D1C1B4', // Taupe
};

function fixFilterSwatchColours() {
  document.querySelectorAll('label.filter-swatch').forEach(label => {
    const nameEl = label.querySelector('.visually-hidden');
    if (!nameEl) return;
    const name = nameEl.textContent.trim().toLowerCase();
    const hex = LAFIT_FILTER_COLOURS[name];
    if (hex) label.style.setProperty('--swatch-background', hex);
  });
}

document.addEventListener('DOMContentLoaded', fixFilterSwatchColours);
document.addEventListener('shopify:section:load', fixFilterSwatchColours);
const filterObserver = new MutationObserver(() => fixFilterSwatchColours());
filterObserver.observe(document.body, { childList: true, subtree: true });


/* ============================================================
   3. PDP GALLERY — COLOUR VARIANT IMAGE FILTER
   Filters the main gallery and thumbnail strip on the product
   detail page to show only images matching the selected colour.

   ALT TEXT CONVENTION FOR KRISTINA:
   ─────────────────────────────────
   Use the hyphenated lowercase colour slug in the image alt text.

   Available slugs:
     mocha · cream · white · choco · iced-latte
     blue-cream · chai · espresso · black

   Single colour:   "blue-cream" or "blue-cream - front"
   Multiple colours: "white, cream" or "blue-cream, chai"
   Generic/all:     Just the product name, no colour slug.
                    These images will show for every colour.

   NOTE: This script hides/shows the slide wrapper divs.
   If Swiper re-renders and undoes visibility, the MutationObserver
   below will re-trigger the filter automatically.
   ============================================================ */

const LAFIT_GALLERY_COLOURS = [
  'mocha', 'cream', 'white', 'choco', 'iced-latte',
  'blue-cream', 'chai', 'espresso', 'black', 'dark-cherry', 'matte-beige', 'white-baby-blue'
];

function parseAltColours(alt) {
  // Split on comma, trim, lowercase each segment
  return alt.split(',').map(s => s.trim().toLowerCase());
}

function altMatchesColour(alt, selectedSlug) {
  const segments = parseAltColours(alt);
  // Each segment must exactly equal a known colour slug,
  // or start with the slug followed by a space/dash (e.g. "blue-cream - front")
  return segments.some(seg => {
    // Strip any descriptor after first space or dash following the colour name
    // e.g. "blue-cream - front" → check if it starts with "blue-cream"
    return seg === selectedSlug || seg.startsWith(selectedSlug + ' ') || seg.startsWith(selectedSlug + '-');
  });
}

function getSelectedColourSlug(section) {
  const checked = section.querySelector(
    'input.variant-options[data-option-position="1"]:checked'
  );
  if (!checked) return null;
  // Convert variant option value to slug format: lowercase, spaces to hyphens
  return checked.dataset.optionValue.trim().toLowerCase().replace(/\s*\+\s*/g,"-").replace(/\s+/g,"-");
}

function filterGallerySlides(section) {
  const selectedSlug = getSelectedColourSlug(section);
  if (!selectedSlug) return;

  const allSlides = section.querySelectorAll('.media-gallery__image.swiper-slide');

  allSlides.forEach(slide => {
    const img = slide.querySelector('img');
    if (!img) return;

    const alt = (img.alt || '').toLowerCase().trim();

    // Check if the alt text contains ANY known colour slug
    const hasColourTag = LAFIT_GALLERY_COLOURS.some(slug =>
      parseAltColours(alt).some(seg =>
        seg === slug || seg.startsWith(slug + ' ') || seg.startsWith(slug + '-')
      )
    );

    if (!hasColourTag) {
      // No colour tag — generic image, show for all colours
      slide.style.display = '';
    } else if (altMatchesColour(alt, selectedSlug)) {
      // Matches selected colour
      slide.style.display = '';
    } else {
      // Has a colour tag but doesn't match — hide
      slide.style.display = 'none';
    }
  });
}

function initGalleryFilter() {
  document.querySelectorAll('.sec__main-product').forEach(section => {
    filterGallerySlides(section);
  });
}

// Document-level delegation — catches swatch changes even after theme JS re-renders
document.addEventListener('change', e => {
  if (e.target.matches('input.variant-options')) {
    const section = e.target.closest('.sec__main-product');
    if (section) {
      setTimeout(() => filterGallerySlides(section), 800);
    }
  }
});

// Delay init to allow Swiper to fully render first
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(initGalleryFilter, 500);
});
document.addEventListener('shopify:section:load', () => {
  setTimeout(initGalleryFilter, 500);
});

// Re-run if Swiper re-renders slides
const galleryObserver = new MutationObserver(() => {
  document.querySelectorAll('.sec__main-product').forEach(section => {
    filterGallerySlides(section);
  });
});
galleryObserver.observe(document.body, { childList: true, subtree: true });